"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacing = exports.sizeToPx = void 0;

var _styledComponents = require("styled-components");

var _Theme = require("./Theme.media");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  /* Spacing margin */\n  ", ";\n\n  /* Spacing margin */\n  ", ";\n\n  ", ";\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  /* Spacing padding */\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Uses props to generate padding and margin for sizes and left, right, ect...


var spacing = function spacing(props) {
  return (0, _styledComponents.css)(_templateObject(), generateSpacing('margin', undefined, props.margin, props.marginXs, props.marginSm, props.marginMd, props.marginLg, props.marginXl), generateSpacing('margin', 'top', props.marginTop, props.marginXsTop, props.marginSmTop, props.marginMdTop, props.marginLgTop, props.marginXlTop), generateSpacing('margin', 'right', props.marginRight, props.marginXsRight, props.marginSmRight, props.marginMdRight, props.marginLgRight, props.marginXlRight), generateSpacing('margin', 'bottom', props.marginBottom, props.marginXsBottom, props.marginSmBottom, props.marginMdBottom, props.marginLgBottom, props.marginXlBottom), generateSpacing('margin', 'left', props.marginLeft, props.marginXsLeft, props.marginSmLeft, props.marginMdLeft, props.marginLgLeft, props.marginXlLeft), generateSpacing('margin', 'x', props.marginX, props.marginXsX, props.marginSmX, props.marginMdX, props.marginLgX, props.marginXlX), generateSpacing('margin', 'y', props.marginY, props.marginXsY, props.marginSmY, props.marginMdY, props.marginLgY, props.marginXlY), generateSpacing('padding', undefined, props.padding, props.paddingXs, props.paddingSm, props.paddingMd, props.paddingLg, props.paddingXl), generateSpacing('padding', 'top', props.paddingTop, props.paddingXsTop, props.paddingSmTop, props.paddingMdTop, props.paddingLgTop, props.paddingXlTop), generateSpacing('padding', 'right', props.paddingRight, props.paddingXsRight, props.paddingSmRight, props.paddingMdRight, props.paddingLgRight, props.paddingXlRight), generateSpacing('padding', 'bottom', props.paddingBottom, props.paddingXsBottom, props.paddingSmBottom, props.paddingMdBottom, props.paddingLgBottom, props.paddingXlBottom), generateSpacing('padding', 'left', props.paddingLeft, props.paddingXsLeft, props.paddingSmLeft, props.paddingMdLeft, props.paddingLgLeft, props.paddingXlLeft), generateSpacing('padding', 'x', props.paddingX, props.paddingXsX, props.paddingSmX, props.paddingMdX, props.paddingLgX, props.paddingXlX), generateSpacing('padding', 'y', props.paddingY, props.paddingXsY, props.paddingSmY, props.paddingMdY, props.paddingLgY, props.paddingXlY));
}; // Take the screen breakpoints and dispatch the function spacingCss() if
// that screen size is avaiable. We need to check specifically for undefined
// because standard,sm,md,lg,xl can be 0. Which is a falsy value in javascript.


exports.spacing = spacing;

var generateSpacing = function generateSpacing(type, position, standard, xs, sm, md, lg, xl) {
  return (0, _styledComponents.css)(_templateObject2(), standard !== undefined && spacingCss(type, position, standard), xs !== undefined && _Theme.media.xs(_templateObject3(), spacingCss(type, position, xs)), sm !== undefined && _Theme.media.sm(_templateObject4(), spacingCss(type, position, sm)), md !== undefined && _Theme.media.md(_templateObject5(), spacingCss(type, position, md)), lg !== undefined && _Theme.media.lg(_templateObject6(), spacingCss(type, position, lg)), xl !== undefined && _Theme.media.xl(_templateObject7(), spacingCss(type, position, xl)));
}; // generate the line specific css for padding or margin


var spacingCss = function spacingCss(type, position, spacing) {
  // check for valid types
  if (type !== 'margin' && type !== 'padding') {
    throw new Error("Invalid position type ".concat(type, "."));
  } // check that spacing is between 0 and 6


  if (parseInt(spacing, 10) < 0 || parseInt(spacing, 10) > 6) {
    throw new Error("Spacing value must be between 0 and 6. You passed in ".concat(spacing, "."));
  } // generate and return positions
  // Important Note: Notice the `!important` tag below. We need this to be
  // able to overwrite any default spacing that may exist in a media query
  // from components like `column`, that have 16px of default spacing. We
  // could do a bunch of logic instead, but why not just use whats built into
  // css. `!important` should be used very sparingly.


  if (position === undefined) {
    return "".concat(type, ": ").concat(sizeToPx[spacing], "px !important;");
  } else if (position === 'top') {
    return "".concat(type, "-top: ").concat(sizeToPx[spacing], "px !important;");
  } else if (position === 'right') {
    return "".concat(type, "-right: ").concat(sizeToPx[spacing], "px !important;");
  } else if (position === 'bottom') {
    return "".concat(type, "-bottom: ").concat(sizeToPx[spacing], "px !important;");
  } else if (position === 'left') {
    return "".concat(type, "-left: ").concat(sizeToPx[spacing], "px !important;");
  } else if (position === 'x') {
    return "".concat(type, "-right: ").concat(sizeToPx[spacing], "px !important;\n    ").concat(type, "-left: ").concat(sizeToPx[spacing], "px !important;\n    ");
  } else if (position === 'y') {
    return "".concat(type, "-top: ").concat(sizeToPx[spacing], "px !important;\n    ").concat(type, "-bottom: ").concat(sizeToPx[spacing], "px !important;\n    ");
  } else {
    throw new Error("Invalid spacing property ".concat(position));
  }
};

var sizeToPx = {
  n6: -128,
  n5: -64,
  n4: -32,
  n3: -16,
  n2: -8,
  n1: -4,
  0: 0,
  1: 4,
  2: 8,
  3: 16,
  4: 32,
  5: 64,
  6: 128
};
exports.sizeToPx = sizeToPx;